import React from 'react';
import oauthService from '../services/oauthService';
import { useTranslation } from '../i18n/useTranslation';
import KakaoIcon from '../asset/icon/kakao_symbol.png';
import GoogleIdentityButton from './GoogleIdentityButton';

// 카카오/구글 소셜 로그인 버튼. popup-login(이메일 로그인 팝업)과
// gnb-login-induce-panel(비로그인 GNB2)에서 동일한 동작/UX를 공유하기 위한 컴포넌트.
function SocialLoginButtons({ variant = 'popup', onSuccess, onError }) {
    const { t } = useTranslation();

    const handleKakaoLogin = async (e) => {
        if (e) e.preventDefault();
        try {
            await oauthService.kakaoLogin();
        } catch (error) {
            console.error('Kakao login failed:', error);
            if (onError) onError('kakao', error);
        }
    };

    if (variant === 'menu') {
        return (
            <>
                <button type="button" className="side-menu-item gnb-login-induce-btn gnb-login-induce-btn-kakao" onClick={handleKakaoLogin}>
                    <img src={KakaoIcon} className="gnb-login-induce-icon" alt="Kakao" />
                    <span className="gnb-menu-inv">{t('login.kakao')}</span>
                </button>
                <GoogleIdentityButton
                    className="google-identity-menu"
                    width={240}
                    onSuccess={(result) => onSuccess && onSuccess('google', result)}
                    onError={(error) => onError && onError('google', error)}
                />
            </>
        );
    }

    return (
        <>
            <button className="popup-login-social-button popup-login-kakao" onClick={handleKakaoLogin}>
                <img src={KakaoIcon} alt="카카오" className="popup-login-social-icon" />
                <span>{t('login.kakao')}</span>
                <span className="popup-login-social-icon-placeholder"></span>
            </button>
            <GoogleIdentityButton
                width={260}
                onSuccess={(result) => onSuccess && onSuccess('google', result)}
                onError={(error) => onError && onError('google', error)}
            />
        </>
    );
}

export default SocialLoginButtons;
